const vistaProductSpecs = {
  '43"': [
    { label: "Resolution", value: "4K UHD (3840*2160)" },
    { label: "Brightness(nits)", value: "400" },
    { label: "TV Reception", value: "NTSC / ATSC / Clear QAM" },
    { label: "HDR (10 Pro / HLG)", value: "Yes" },
    { label: "Audio Output", value: "2*10W" },
    {
      label: "Speaker System",
      value: "2.0 ch",
    },
    { label: "Set Side", value: "HDMI In 2(2.0), USB (2.0)" },
    {
      label: "Set Rear",
      value:
        "RS-232C (D-Sub 9pin (Control & Service)), RJ45 (Usage Purpose 2 (Ethernet, SNMP)), Debug (Phone Jack Type), HDMI In (HDCP (2.0)), RF In (tuner), AV In (Phone Jack Type), Digital Audio Out (Optical), External Speaker Out (3.5mm phone jack (Spk-out fixed 0.01~1.00W and line out))",
    },
    {
      label: "W x H x D / Weight(without stand)",
      value: "1,463 x 850 x 87.8 / 21.3 kg",
    },
    {
      label: "W x H x D / Weight(with stand)",
      value: "1,463 x 914 x 269 / 21.6 kg",
    },
    {
      label: "W x H x D / Weight (Shipping)",
      value: "1,600 x 970 x 190 / 28.4 kg",
    },
    { label: "Voltage", value: "AC 120 V ~ 50 / 60 Hz" },
    { label: "Stand-by", value: "Under 0.5W" },
    { label: "Power Consumption", value: "180.3W" },
  ],
  '55"': [
    { label: "Resolution", value: "4K UHD (3840*2160)" },
    { label: "Brightness(nits)", value: "400" },
    { label: "TV Reception", value: "NTSC / ATSC / Clear QAM" },
    { label: "HDR (10 Pro / HLG)", value: "Yes" },
    { label: "Audio Output", value: "2*10W" },
    {
      label: "Speaker System",
      value: "2.0 ch",
    },
    { label: "Set Side", value: "HDMI In 2(2.0), USB (2.0)" },
    {
      label: "Set Rear",
      value:
        "RS-232C (D-Sub 9pin (Control & Service)), RJ45 (Usage Purpose 2 (Ethernet, SNMP)), Debug (Phone Jack Type), HDMI In (HDCP (2.0)), RF In (tuner), AV In (Phone Jack Type), Digital Audio Out (Optical), External Speaker Out (3.5mm phone jack (Spk-out fixed 0.01~1.00W and line out))",
    },
    {
      label: "W x H x D / Weight(without stand)",
      value: "1,463 x 850 x 87.8 / 21.3 kg",
    },
    {
      label: "W x H x D / Weight(with stand)",
      value: "1,463 x 914 x 269 / 21.6 kg",
    },
    {
      label: "W x H x D / Weight (Shipping)",
      value: "1,600 x 970 x 190 / 28.4 kg",
    },
    { label: "Voltage", value: "AC 120 V ~ 50 / 60 Hz" },
    { label: "Stand-by", value: "Under 0.5W" },
    { label: "Power Consumption", value: "180.3W" },
  ],
  '65"': [
    { label: "Resolution", value: "4K UHD (3840*2160)" },
    { label: "Brightness(nits)", value: "400" },
    { label: "TV Reception", value: "NTSC / ATSC / Clear QAM" },
    { label: "HDR (10 Pro / HLG)", value: "Yes" },
    { label: "Audio Output", value: "2*10W" },
    {
      label: "Speaker System",
      value: "2.0 ch",
    },
    { label: "Set Side", value: "HDMI In 2(2.0), USB (2.0)" },
    {
      label: "Set Rear",
      value:
        "RS-232C (D-Sub 9pin (Control & Service)), RJ45 (Usage Purpose 2 (Ethernet, SNMP)), Debug (Phone Jack Type), HDMI In (HDCP (2.0)), RF In (tuner), AV In (Phone Jack Type), Digital Audio Out (Optical), External Speaker Out (3.5mm phone jack (Spk-out fixed 0.01~1.00W and line out))",
    },
    {
      label: "W x H x D / Weight(without stand)",
      value: "1,463 x 850 x 87.8 / 21.3 kg",
    },
    {
      label: "W x H x D / Weight(with stand)",
      value: "1,463 x 914 x 269 / 21.6 kg",
    },
    {
      label: "W x H x D / Weight (Shipping)",
      value: "1,600 x 970 x 190 / 28.4 kg",
    },
    { label: "Voltage", value: "AC 120 V ~ 50 / 60 Hz" },
    { label: "Stand-by", value: "Under 0.5W" },
    { label: "Power Consumption", value: "180.3W" },
  ],
  '75"': [
    { label: "Resolution", value: "4K UHD (3840*2160)" },
    { label: "Brightness(nits)", value: "400" },
    { label: "TV Reception", value: "NTSC / ATSC / Clear QAM" },
    { label: "HDR (10 Pro / HLG)", value: "Yes" },
    { label: "Audio Output", value: "2*10W" },
    {
      label: "Speaker System",
      value: "2.0 ch",
    },

    { label: "Set Side", value: "HDMI In 2(2.0), USB (2.0)" },
    {
      label: "Set Rear",
      value:
        "RS-232C (D-Sub 9pin (Control & Service)), RJ45 (Usage Purpose 2 (Ethernet, SNMP)), Debug (Phone Jack Type), HDMI In (HDCP (2.0)), RF In (tuner), AV In (Phone Jack Type), Digital Audio Out (Optical), External Speaker Out (3.5mm phone jack (Spk-out fixed 0.01~1.00W and line out))",
    },
    {
      label: "W x H x D / Weight(without stand)",
      value: "1,463 x 850 x 87.8 / 21.3 kg",
    },
    {
      label: "W x H x D / Weight(with stand)",
      value: "1,463 x 914 x 269 / 21.6 kg",
    },
    {
      label: "W x H x D / Weight (Shipping)",
      value: "1,600 x 970 x 190 / 28.4 kg",
    },
    { label: "Voltage", value: "AC 120 V ~ 50 / 60 Hz" },
    { label: "Stand-by", value: "Under 0.5W" },
    { label: "Power Consumption", value: "180.3W" },
  ],
  '86"': [
    { label: "Resolution", value: "4K UHD (3840*2160)" },
    { label: "Brightness(nits)", value: "400" },
    { label: "TV Reception", value: "NTSC / ATSC / Clear QAM" },
    { label: "HDR (10 Pro / HLG)", value: "Yes" },
    { label: "Audio Output", value: "2*10W" },
    {
      label: "Speaker System",
      value: "2.0 ch",
    },

    { label: "Set Side", value: "HDMI In 2(2.0), USB (2.0)" },
    {
      label: "Set Rear",
      value:
        "RS-232C (D-Sub 9pin (Control & Service)), RJ45 (Usage Purpose 2 (Ethernet, SNMP)), Debug (Phone Jack Type), HDMI In (HDCP (2.0)), RF In (tuner), AV In (Phone Jack Type), Digital Audio Out (Optical), External Speaker Out (3.5mm phone jack (Spk-out fixed 0.01~1.00W and line out))",
    },
    {
      label: "W x H x D / Weight(without stand)",
      value: "1,463 x 850 x 87.8 / 21.3 kg",
    },
    {
      label: "W x H x D / Weight(with stand)",
      value: "1,463 x 914 x 269 / 21.6 kg",
    },
    {
      label: "W x H x D / Weight (Shipping)",
      value: "1,600 x 970 x 190 / 28.4 kg",
    },
    { label: "Voltage", value: "AC 120 V ~ 50 / 60 Hz" },
    { label: "Stand-by", value: "Under 0.5W" },
    { label: "Power Consumption", value: "180.3W" },
  ],
  '98"': [
    { label: "Resolution", value: "4K UHD (3840*2160)" },
    { label: "Brightness(nits)", value: "400" },
    { label: "TV Reception", value: "NTSC / ATSC / Clear QAM" },
    { label: "HDR (10 Pro / HLG)", value: "Yes" },
    { label: "Audio Output", value: "2*10W" },
    {
      label: "Speaker System",
      value: "2.0 ch",
    },

    { label: "Set Side", value: "HDMI In 2(2.0), USB (2.0)" },
    {
      label: "Set Rear",
      value:
        "RS-232C (D-Sub 9pin (Control & Service)), RJ45 (Usage Purpose 2 (Ethernet, SNMP)), Debug (Phone Jack Type), HDMI In (HDCP (2.0)), RF In (tuner), AV In (Phone Jack Type), Digital Audio Out (Optical), External Speaker Out (3.5mm phone jack (Spk-out fixed 0.01~1.00W and line out))",
    },
    {
      label: "W x H x D / Weight(without stand)",
      value: "1,463 x 850 x 87.8 / 21.3 kg",
    },
    {
      label: "W x H x D / Weight(with stand)",
      value: "1,463 x 914 x 269 / 21.6 kg",
    },
    {
      label: "W x H x D / Weight (Shipping)",
      value: "1,600 x 970 x 190 / 28.4 kg",
    },
    { label: "Voltage", value: "AC 120 V ~ 50 / 60 Hz" },
    { label: "Stand-by", value: "Under 0.5W" },
    { label: "Power Consumption", value: "180.3W" },
  ],
};

export default vistaProductSpecs;
